export default __webpack_public_path__ + "static/media/bg.80dae56d.jpg";